import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import SignUp from '@/views/SignUp'
import QueryResult from '@/views/QueryResult'
import ExamBook from '@/views/ExamBook'
import ReceiptBook from '@/views/ReceiptBook'
import PrintTrainDoc from '@/views/PrintTrainDoc'
import PrintProve from '@/views/PrintProve'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '山西传人科技在线报名系统',
        menuShow: true,
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
        title: '山西传人科技在线报名系统',
        menuShow: true,
      }
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      meta: {
        title: '山西传人科技在线报名系统 - 在线报名',
        menuShow: true,
      }
    },
    {
      path: '/queryresult',
      name: 'QueryResult',
      component: QueryResult,
      meta: {
        title: '山西传人科技在线报名系统 - 查询结果',
        menuShow: true,
      }
    },
    {
      path: '/queryresult',
      name: 'QueryResult',
      component: QueryResult,
      meta: {
        title: '山西传人科技在线报名系统 - 查询结果',
        menuShow: true,
      }
    },
    {
      path: '/exambook',
      name: 'ExamBook',
      component: ExamBook,
      meta: {
        title: '山西传人科技在线报名系统 - 准考证打印',
        menuShow: false,
      }
    },
    {
      path: '/receiptbook',
      name: 'ReceiptBook',
      component: ReceiptBook,
      meta: {
        title: '山西传人科技在线报名系统 - 报名回执单打印',
        menuShow: false,
      }
    },
    {
      path: '/printtraindoc',
      name: 'PrintTrainDoc',
      component: PrintTrainDoc,
      meta: {
        title: '山西传人科技在线报名系统 - 培训档案打印',
        menuShow: false,
      }
    },
    {
      path: '/printprove',
      name: 'PrintProve',
      component: PrintProve,
      meta: {
        title: '山西传人科技在线报名系统 - 学时证明打印',
        menuShow: false,
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js